import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { useTheme } from "@mui/material";

import { Box } from "@/Components/v2/atoms/Box";
import { BetaPillWithTooltip } from "@/Components/v2/atoms/Pill";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Tooltip } from "@/Components/v2/atoms/ToolTip";
import { Typography } from "@/Components/v2/atoms/Typography";
import { ShareButton } from "@/Components/v2/molecule/ShareButton/ShareButton";
import DatePickerWrapper from "@/shared/components/date-range/components/DatePickerWrapper";
import { useFeatureGate } from "@statsig/react-bindings";
import { featureFlag } from "@/context/FeatureFlagProvider/featureFlags";

interface TitleProps {
  title: string;
  subtitle: string;
  isBeta?: boolean;
}

const Title: React.FC<TitleProps> = ({ title, subtitle, isBeta = false }) => {
  const theme = useTheme();
  const betaHelperText = `${title} is in limited release as we gather customer feedback and make further improvements. Please contact your Account Manager with any questions or suggestions.`;
  const { value: isTopNavLayoutEnabled } = useFeatureGate(featureFlag.topNavLayout);
  const titleMarginTop = isTopNavLayoutEnabled ? 0 : 2;
  const datePickerPaddingTop = isTopNavLayoutEnabled ? 0 : 2;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      paddingRight={4}
      paddingLeft={2}
      spacing={2}
    >
      <Box flexGrow={1} maxWidth="70%">
        <Stack
          direction="row"
          alignItems="center"
          marginLeft={2}
          marginTop={titleMarginTop}
          spacing={1}
        >
          <Typography variant="h4" fontWeight={600}>
            {title} {isBeta && <BetaPillWithTooltip title={betaHelperText} />}
          </Typography>
          <Tooltip
            title={
              <Typography variant="body1" padding={1} sx={{ color: theme.palette.common.white }}>
                {subtitle}
              </Typography>
            }
            placement="bottom"
          >
            <HelpOutlineOutlinedIcon sx={{ color: theme.palette.brandedTypography.textColor }} />
          </Tooltip>
        </Stack>
      </Box>
      <Stack
        flexShrink={0}
        paddingTop={datePickerPaddingTop}
        direction={"row"}
        alignItems={"center"}
        spacing={2}
      >
        <DatePickerWrapper />
        <ShareButton />
      </Stack>
    </Stack>
  );
};

export default Title;
